import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Auth.css";

export default function SignupPage() {
  const navigate = useNavigate();
  const [institutionName, setInstitutionName] = useState("");
  const [address, setAddress] = useState("");
  const [affiliatedUniversity, setAffiliatedUniversity] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("typeace-theme") || "light";
  })
  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccessMessage("");
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          institutionName,
          address,
          affiliatedUniversity,
          email,
          password,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setSuccessMessage(`Registration successful. Your College Code is: ${data.collegeCode}`);
        setTimeout(() => {
          navigate("/login");
        }, 4000);
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  //theme
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("typeace-theme", theme);
  }, [theme]);

  return (
    <div className="auth-container" data-theme="light">
      {/* Background Effects */}
      <div className="auth-grid-bg"></div>
      <div className="auth-noise-overlay"></div>
      <div className="auth-orb auth-orb-1"></div>
      <div className="auth-orb auth-orb-2"></div>

      <div className="auth-card-wrapper">
        {/* Brand Section */}
        <div className="auth-brand">
          <svg className="auth-brand-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
          </svg>
          <span onClick={() => (navigate('/'))} className="auth-brand-name">TypeAce</span>
        </div>

        {/* Auth Card */}
        <div className="auth-card">
          <h1 className="auth-title">Institution Registration</h1>
          <p className="auth-subtitle">Register your college or university</p>

          {error && (
            <div className="auth-message auth-message-error">
              <span>⚠️</span>
              {error}
            </div>
          )}

          {successMessage && (
            <div className="auth-message auth-message-success">
              <span>✅</span>
              {successMessage}
            </div>
          )}

          <form onSubmit={handleSignup} className="auth-form">
            {/* Institution Name Field */}
            <div className="input-field-container">
              <label className="input-label">
                Institution Name <span className="input-required">*</span>
              </label>
              <div className="input-wrapper">
                <input
                  type="text"
                  placeholder="e.g., Stanford University"
                  value={institutionName}
                  onChange={(e) => setInstitutionName(e.target.value)}
                  required
                  className="input-element"
                />
              </div>
            </div>

            {/* Address Field */}
            <div className="input-field-container">
              <label className="input-label">
                Address <span className="input-required">*</span>
              </label>
              <div className="input-wrapper">
                <input
                  type="text"
                  placeholder="Street, City, State, ZIP"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  required
                  className="input-element"
                />
              </div>
            </div>

            {/* Affiliated University Field */}
            <div className="input-field-container">
              <label className="input-label">
                Affiliated University <span className="input-required">*</span>
              </label>
              <div className="input-wrapper">
                <input
                  type="text"
                  placeholder="e.g., University of California"
                  value={affiliatedUniversity}
                  onChange={(e) => setAffiliatedUniversity(e.target.value)}
                  required
                  className="input-element"
                />
              </div>
            </div>

            {/* Email Field */}
            <div className="input-field-container">
              <label className="input-label">
                Email <span className="input-required">*</span>
              </label>
              <div className="input-wrapper">
                <input
                  type="email"
                  placeholder="admin@institution.edu"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="input-element"
                />
              </div>
            </div>

            {/* Password Field */}
            <div className="input-field-container">
              <label className="input-label">
                Password <span className="input-required">*</span>
              </label>
              <div className="input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="input-element"
                  minLength={6}
                />
                <button
                  type="button"
                  className="input-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? "👁️" : "👁️‍🗨️"}
                </button>
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="btn btn-primary btn-full-width"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="btn-spinner">⌛</span>
                  Registering Institution...
                </>
              ) : (
                "Register Institution"
              )}
            </button>
          </form>

          {/* Footer Links */}
          <div className="auth-footer-links">
            <p className="auth-footer-text">
              Already registered?
              <a href="/login" className="auth-link">
                Log in
              </a>
            </p>
          </div>

          <div className="auth-footer">
            <p>© 2024 TypeAce. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
}